"use client";

import React from "react";
import Image from "next/image";
import { ThumbsUp } from "lucide-react";
import { useRouter } from "next/navigation";
import { HoverableMention } from "./HoverableMention";
import Link from "next/link";
import defaultProfile from "@/images/default-profile.jpg";

export type Reaction_INFO = {
  reaction_id: string;
  reaction_by: {
    id: string;
    name: string;
    display_name: string;
    profile_picture: {
      url: string;
    };
  };
  reaction_type: string;
};

type ProfilePicture = {
  url: string;
};

function ReactionCard({ reaction }: { reaction: Reaction_INFO }) {
  const router = useRouter();

  const user = {
    id: reaction.reaction_by.id,
    name: reaction.reaction_by.display_name,
    username: reaction.reaction_by.name,
    avatar: reaction.reaction_by.profile_picture?.url,
  };

  return (
    <div className="flex items-center justify-between p-3 border-b border-gray-900 ">
      <HoverableMention user={user}>
        <Link
          href={`/profile/${user.username}`}
          className="flex items-center gap-2"
        >
          <div className="relative w-10 h-10">
            <Image
              src={user.avatar || defaultProfile}
              alt={user.name || "Profile Picture"}
              width={200}
              height={200}
              className="rounded-full object-cover"
            />
          </div>

          <div className="font-bold dark:text-white max-w-[70%] truncate whitespace-nowrap">
            {user.name ?? user.username}
          </div>
        </Link>
      </HoverableMention>

      <div className="sticky right-4">
        <ThumbsUp
          size={20}
          fill="gold"
          strokeWidth={1}
          color="black"
          className="animate-heart-beat dark"
        />
      </div>
    </div>
  );
}

export default ReactionCard;
